import { render } from "./TangkiPerolehan.vue?vue&type=template&id=c1ad7bde"
import script from "./TangkiPerolehan.vue?vue&type=script&lang=js"
export * from "./TangkiPerolehan.vue?vue&type=script&lang=js"

import "./TangkiPerolehan.vue?vue&type=style&index=0&id=c1ad7bde&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__